// Fix for React 19 environment variable access
const BACKEND_URL = import.meta.env?.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API = `${BACKEND_URL}/api`;

export { BACKEND_URL, API };
